import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { BRAND, IMAGES } from "@/lib/content";

const waLink = `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent("Hi Komel, I'd like a free initial consultation.")}`;

export default function CTABand() {
  return (
    <section className="relative overflow-hidden py-24 md:py-32" data-testid="cta-band">
      <div className="absolute inset-0 bg-cover bg-center opacity-25" style={{ backgroundImage: `url(${IMAGES.skyline2})` }} />
      <div className="absolute inset-0 bg-gradient-to-r from-[#060A17] via-[#060A17]/85 to-[#060A17]/40" />
      <div className="relative mx-auto max-w-5xl px-6 md:px-8 text-center md:text-left">
        <Reveal>
          <p className="overline text-gold mb-5">Begin Your Transformation</p>
          <h2 className="font-diszplay text-4xl md:text-6xl leading-[0.98] tracking-tight max-w-3xl">
            Align your space with success. Book your consultation today.
          </h2>
          <p className="mt-6 text-[#F8FAFC] text-lg max-w-2xl">
            Get a complimentary initial consultation and discover how Scientific Vastu can transform your home, business or industrial space.
          </p>
          <div className="mt-9 flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
            <Link to="/contact" data-testid="cta-band-book" className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-green px-7 py-4 font-medium text-white transition-all duration-300 hover:-translate-y-1 hover:bg-[#059669]">
              Book a Consultation <ArrowRight size={18} />
            </Link>
            <a href={waLink} target="_blank" rel="noreferrer" data-testid="cta-band-whatsapp" className="inline-flex items-center justify-center gap-2 rounded-full border border-gold/40 px-7 py-4 font-medium text-gold transition-all duration-300 hover:-translate-y-1 hover:bg-gold/10">
              <MessageCircle size={18} /> Free Initial Consultation
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
